import BaseAction from '@/actions/base_action.js'

export default class extends BaseAction {
  execute(spec, component) {
    $tpu.editing = spec.properties
    this.invalidateProjectShow()
    this.refreshProjectShow()
  }
}
